<template>
  <div class="guide_modal" v-show="showGuideModal">
    <div class="guide_overlay"></div>
    <div class="guide_modal_position">
      <div class="guide_modal-card">
        <div class="guide_modal_title d-flex justify-content-between align-items-center">
          <div>{{ $t('modal.guide.title') }}</div>
          <div class="close_modal" @click="closeModal">
            <img style="pointer-events: none" :src="`${$s3}/img/common/guideModal/close.svg?${this.$ver}`" />
          </div>
        </div>
        <div class="guide_modal_layout">
          <div class="d-grid align-items-center" style="overflow: auto">
            <div class="guide_modal-card_web" style="margin: 10px">
              <img
                style="pointer-events: none"
                class="w-100"
                :src="`${$s3}/img/common/guideModal/guide_1_${lang}.webp?${$ver}`"
              />
              <div>
                <div class="guide_modal_content_title" v-html="$t('modal.guide.card.title')"></div>
                <img style="pointer-events: none" :src="`${$s3}/img/common/guideModal/bulb.svg?${$ver}`" />
                <div class="guide_modal_content_content">
                  <div>{{ $t('modal.guide.card.content') }}</div>
                  <div>{{ $t('modal.guide.card.content1') }}</div>
                  <div>{{ $t('modal.guide.card.content2') }}</div>
                </div>
              </div>
            </div>
            <div class="guide_modal-card_web" style="margin: 10px">
              <img
                style="pointer-events: none"
                class="w-100"
                :src="`${$s3}/img/common/guideModal/guide_2_${lang}.webp?${$ver}`"
              />
              <div>
                <div class="guide_modal_content_title" v-html="$t('modal.guide.card2.title')"></div>
                <img style="pointer-events: none" :src="`${$s3}/img/common/guideModal/bulb.svg?${$ver}`" />
                <div class="guide_modal_content_content">
                  <div>{{ $t('modal.guide.card2.content') }}</div>
                  <div>{{ $t('modal.guide.card2.content1') }}</div>
                  <div>{{ $t('modal.guide.card2.content2') }}</div>
                </div>
              </div>
            </div>
            <div class="guide_modal-card_web" style="margin: 10px">
              <img
                style="pointer-events: none"
                class="w-100"
                :src="`${$s3}/img/common/guideModal/guide_3_${lang}.webp?${$ver}`"
              />
              <div>
                <div class="guide_modal_content_title" v-html="$t('modal.guide.card3.title')"></div>
                <img style="pointer-events: none" :src="`${$s3}/img/common/guideModal/bulb.svg?${$ver}`" />
                <div class="guide_modal_content_content">
                  <div>{{ $t('modal.guide.card3.content') }}</div>
                  <div>{{ $t('modal.guide.card3.content1') }}</div>
                </div>
              </div>
            </div>
            <div class="guide_modal-card_web" style="margin: 10px">
              <img
                style="pointer-events: none"
                class="w-100"
                :src="`${$s3}/img/common/guideModal/guide_4_${lang}.webp?${$ver}`"
              />
              <div>
                <div class="guide_modal_content_title" v-html="$t('modal.guide.card4.title')"></div>
                <img style="pointer-events: none" :src="`${$s3}/img/common/guideModal/bulb.svg?${$ver}`" />
                <div class="guide_modal_content_content">
                  <div>{{ $t('modal.guide.card4.content') }}</div>
                  <div>{{ $t('modal.guide.card4.content3') }}</div>
                  <div>{{ $t('modal.guide.card4.content4') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Flicking :options="{ circular: true }" :plugins="plugin">
          <!-- :plugins="pluginsbig" -->
          <div class="guide_modal-card_mobile">
            <img
              style="pointer-events: none"
              class="w-100"
              :src="`${$s3}/img/common/guideModal/guide_1_${lang}.webp?${$ver}`"
            />
            <div>
              <div class="guide_modal_content_title" v-html="$t('modal.guide.card.title')"></div>
              <img style="pointer-events: none" :src="`${$s3}/img/common/guideModal/bulb.svg?${$ver}`" />
              <div class="guide_modal_content_content">
                <div>{{ $t('modal.guide.card.content') }}</div>
                <div>{{ $t('modal.guide.card.content1') }}</div>
                <div>{{ $t('modal.guide.card.content2') }}</div>
              </div>
            </div>
          </div>
          <div class="guide_modal-card_mobile">
            <img
              style="pointer-events: none"
              class="w-100"
              :src="`${$s3}/img/common/guideModal/guide_bottom_sheet_${lang}.webp?${$ver}`"
            />
            <div>
              <div class="guide_modal_content_title" v-html="$t('modal.guide.card1.title')"></div>
              <img style="pointer-events: none" :src="`${$s3}/img/common/guideModal/bulb.svg?${$ver}`" />
              <div class="guide_modal_content_content">
                <div>{{ $t('modal.guide.card1.content') }}</div>
                <div>{{ $t('modal.guide.card1.content1') }}</div>
                <div>{{ $t('modal.guide.card1.content2') }}</div>
              </div>
            </div>
          </div>
          <div class="guide_modal-card_mobile">
            <img
              style="pointer-events: none"
              class="w-100"
              :src="`${$s3}/img/common/guideModal/guide_2_${lang}_mobile.webp?${$ver}`"
            />
            <div>
              <div class="guide_modal_content_title" v-html="$t('modal.guide.card2.title')"></div>
              <img style="pointer-events: none" :src="`${$s3}/img/common/guideModal/bulb.svg?${$ver}`" />
              <div class="guide_modal_content_content">
                <div>{{ $t('modal.guide.card2.content') }}</div>
                <div>{{ $t('modal.guide.card2.content1') }}</div>
                <div>{{ $t('modal.guide.card2.content2') }}</div>
              </div>
            </div>
          </div>
          <div class="guide_modal-card_mobile">
            <img
              style="pointer-events: none"
              class="w-100"
              :src="`${$s3}/img/common/guideModal/guide_3_${lang}.webp?${$ver}`"
            />
            <div>
              <div class="guide_modal_content_title" v-html="$t('modal.guide.card3.title')"></div>
              <img style="pointer-events: none" :src="`${$s3}/img/common/guideModal/bulb.svg?${$ver}`" />
              <div class="guide_modal_content_content">
                <div>{{ $t('modal.guide.card3.content') }}</div>
                <div>{{ $t('modal.guide.card3.content1') }}</div>
              </div>
            </div>
          </div>
          <div class="guide_modal-card_mobile">
            <img
              style="pointer-events: none"
              class="w-100"
              :src="`${$s3}/img/common/guideModal/guide_4_${lang}.webp?${$ver}`"
            />
            <div>
              <div class="guide_modal_content_title" v-html="$t('modal.guide.card4.title')"></div>
              <img style="pointer-events: none" :src="`${$s3}/img/common/guideModal/bulb.svg?${$ver}`" />
              <div class="guide_modal_content_content">
                <div>{{ $t('modal.guide.card4.content') }}</div>
                <div>{{ $t('modal.guide.card4.content3') }}</div>
                <div>{{ $t('modal.guide.card4.content4') }}</div>
              </div>
            </div>
          </div>
          <template #viewport>
            <div class="flicking-pagination mb-1"></div>
          </template>
        </Flicking>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Pagination } from '@egjs/flicking-plugins';

export default {
  name: 'GuideModal',
  props: {},
  mounted() {},
  created() {},
  data() {
    return {
      plugin: [new Pagination({ type: 'bullet' })],
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
      lang: (state) => state.lang,
    }),
    showGuideModal() {
      return this.$store.state.showGuideModal;
    },
  },
  methods: {
    closeModal() {
      this.$store.commit('toggleGuideModal', { state: false });
    },
  },
  filters: {
    comma_num(value) {
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
};
</script>

<style lang="scss">
.guide_modal_layout {
  overflow-x: scroll;

  .d-grid {
    grid-template-columns: repeat(4, 1fr);
  }

  .guide_modal-card_web {
    .w-100 {
      max-width: 260px;
    }
  }
}
</style>

<style lang="scss">
$s3: 'https://img.openmeta.city';

@keyframes open_guide_modal {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.guide_modal,
.guide_overlay {
  animation: open_guide_modal 0.2s;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 11;
}
.guide_overlay {
  background-color: rgba(0, 0, 0, 0.3);
}
.guide_modal_position {
  display: grid;
  place-items: center;
  height: calc(calc(var(--vh, 1vh) * 100) - 80px);
}
.guide_modal-card {
  display: inline-block;
  position: relative;
  max-width: 90%;
  max-height: 90%;
  width: auto;
  margin: auto;
  background-color: white;
  z-index: 11;
  opacity: 1;
  overflow: auto;
  border-radius: 5px;
}
.guide_card {
  position: relative;
  height: 380px;
  width: 241px;
  min-width: 241px;
  background-image: url(#{$s3}/img/common/card/frame.svg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.guide_modal_title {
  padding: 32px 32px 12px !important;
  max-width: 100%;
  background-color: #fff;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 22px;
  letter-spacing: -0.1px;
  color: #3972ce;
  position: sticky;
  top: 0;
}
.guide_modal_layout {
  padding: 2px 22px 22px !important;
}
.close_modal {
  cursor: pointer;
}
.guide_info_wrap {
  width: 60%;
  padding-top: 12px;
}
.guide_modal-card_web {
  min-width: 286px;
  z-index: -1;
  display: block;
  position: relative;
  padding: 14px;
  margin-bottom: 45px;
  box-shadow: 0px 0px 4px rgb(0 0 0 / 20%);
  height: calc(100% - 20px);
}
.guide_modal-card_mobile {
  display: none;
}
.guide_modal_content_title {
  padding: 20px 0;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
  color: #333333;
}
.guide_modal_content_content {
  // height: 80px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #666666;
  padding: 10px 0;
}
@media screen and (max-width: 1119px) {
  .guide_modal-card_mobile {
    width: 100%;
    z-index: -1;
    display: block;
    padding: 0px 14px 11px;
    max-height: 415px;
    margin-bottom: 35px;
  }
  .guide_overlay {
    background-color: rgba(0, 0, 0, 0.6);
  }
  .guide_modal_layout {
    display: none;
  }
  .guide_modal_title {
    z-index: 2;
    height: unset;
    padding: 11px 14px !important;
    font-style: normal;
    font-weight: normal;
    line-height: unset;
    font-size: 15px;
    text-align: left;
    letter-spacing: -0.5px;
    color: #666666;
    /* filter: drop-shadow(3px 3px 1px rgba(0, 0, 0, 0.5)); */

    .close_modal {
      img {
        width: 14px;
      }
    }
  }

  .guide_modal_content_title {
    padding: 10px 0;
    font-size: 18px;
  }
  .guide_info_wrap {
    padding-bottom: 12px;
    width: 100%;
    margin: 0 auto;
    font-size: 13px;
  }
}
@media screen and (max-width: 992px) {
  .guide_modal-card_mobile {
    max-height: none;
    margin-bottom: 10px;
  }
  .guide_modal-card {
    max-width: 80%;
    max-height: 100%;
  }
  .guide_modal_layout {
    word-break: keep-all;
    font-size: 14px !important;
  }
}
</style>
